/* CUFT — Bundle Offers
   Renders selectors, gates availability, prices the bundle, adds all items in one cart call. */
(function () {
  'use strict';

  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Products may label options "Size"/"Color"/"Colour" — match loosely.
  function optKey(product, kind) {
    var names = (product.optionNames || []).map(function (n) { return String(n).toLowerCase(); });
    for (var i = 0; i < names.length; i++) {
      if (kind === 'size' && names[i].indexOf('siz') === 0) return names[i];
      if (kind === 'color' && names[i].indexOf('col') === 0) return names[i];
    }
    return null;
  }

  function findVariant(product, wanted) {
    if (!product) return null;
    var keys = Object.keys(wanted);
    return product.variants.find(function (v) {
      return keys.every(function (k) {
        var a = String(v.opts[k] == null ? '' : v.opts[k]).trim().toLowerCase();
        var b = String(wanted[k] == null ? '' : wanted[k]).trim().toLowerCase();
        return a === b;
      });
    }) || null;
  }

  function uniqueValues(product, key) {
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v.opts[key];
      if (val != null && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function sortSizes(list) {
    return list.slice().sort(function (a, b) {
      var ia = SIZE_ORDER.indexOf(String(a).toUpperCase());
      var ib = SIZE_ORDER.indexOf(String(b).toUpperCase());
      if (ia === -1 && ib === -1) return String(a).localeCompare(String(b));
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });
  }

  function swatchColor(name) {
    var map = {
      black: '#000000', charcoal: '#000000',
      caramel: '#CA5B1C', camel: '#CA5B1C', tan: '#CA5B1C',
      blush: '#FAD7BE', nude: '#FAD7BE', cream: '#f0e6dc', white: '#f6f4f1'
    };
    return map[String(name).trim().toLowerCase()] || '#d9d2c9';
  }

  function Bundles(root) {
    var dataEl = root.querySelector('[data-cuft-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[CUFT bundles] could not parse section data', e);
      return;
    }

    var P = data.products || {};
    if (!P.bikini && !P.thong) {
      console.warn('[CUFT bundles] no underwear products assigned in the theme editor.');
    }

    root.querySelectorAll('[data-cuft-tier]').forEach(function (tier) {
      setupTier(tier, P, data, root);
    });

    setupModal(root);
  }

  function setupTier(tier, P, data, root) {
    var pairs = parseInt(tier.dataset.pairs, 10) || 1;

    // Optional whitelist. Blank means "offer every colour the product has".
    var allowed = (tier.dataset.colors || '')
      .split(',')
      .map(function (c) { return c.trim(); })
      .filter(Boolean);

    var wantCami = tier.dataset.includeCami === 'true';
    var wantWash = tier.dataset.includeWash === 'true';

    // colours: { 'Charcoal': 2, 'Blush': 1, ... }
    var state = { style: 'bikini', size: null, colours: {}, camiColor: null, camiSize: null };

    var styleInputs = tier.querySelectorAll('[data-cuft-style]');
    var checked = tier.querySelector('[data-cuft-style]:checked');
    if (checked) state.style = checked.value;

    var sizeWrap = tier.querySelector('[data-cuft-sizes="underwear"]');
    var colourWrap = tier.querySelector('[data-cuft-colours]');
    var colourNote = tier.querySelector('[data-cuft-colour-note]');
    var tallyEl = tier.querySelector('[data-cuft-tally]');
    var resetBtn = tier.querySelector('[data-cuft-reset]');
    var camiColorWrap = tier.querySelector('[data-cuft-colors="cami"]');
    var camiSizeWrap = tier.querySelector('[data-cuft-sizes="cami"]');
    var addBtn = tier.querySelector('[data-cuft-add]');
    var msgEl = tier.querySelector('[data-cuft-msg]');

    /* ---------- helpers ---------- */

    function product() { return P[state.style]; }

    // Colours on offer for the current style, respecting the optional whitelist.
    function palette() {
      var prod = product();
      if (!prod) return [];
      var ck = optKey(prod, 'color');
      if (!ck) return [];
      var list = uniqueValues(prod, ck);
      if (allowed.length) {
        list = list.filter(function (c) {
          return allowed.some(function (a) {
            return String(a).toLowerCase() === String(c).toLowerCase();
          });
        });
      }
      return list;
    }

    function colourInStock(colour, size) {
      var prod = product();
      if (!prod || !size) return false;
      var ck = optKey(prod, 'color');
      var sk = optKey(prod, 'size');
      var wanted = {};
      if (sk) wanted[sk] = size;
      if (ck) wanted[ck] = colour;
      var v = findVariant(prod, wanted);
      return !!(v && v.available);
    }

    // A size is offered when at least one colour is in stock at it.
    function sizeAvailable(size) {
      return palette().some(function (c) { return colourInStock(c, size); });
    }

    function chosen() {
      return Object.keys(state.colours).reduce(function (n, k) {
        return n + (state.colours[k] || 0);
      }, 0);
    }

    // Drop any picks that are no longer purchasable (size change, style change).
    function pruneColours() {
      Object.keys(state.colours).forEach(function (col) {
        if (!colourInStock(col, state.size)) state.colours[col] = 0;
      });
    }

    /* ---------- renderers ---------- */

    function renderSizes() {
      var prod = product();
      if (!prod || !sizeWrap) return;
      var sk = optKey(prod, 'size');
      if (!sk) { sizeWrap.innerHTML = ''; return; }

      var sizes = sortSizes(uniqueValues(prod, sk));

      // Seed a sensible default size the first time round.
      if (!state.size) {
        var firstOk = sizes.find(function (s) { return sizeAvailable(s); });
        state.size = firstOk || null;
      }

      sizeWrap.innerHTML = '';
      sizes.forEach(function (size) {
        var ok = sizeAvailable(size);
        var label = document.createElement('label');
        label.className = 'cuft-chip' + (ok ? '' : ' is-disabled');
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'size-' + (tier.dataset.blockId || 'u');
        input.value = size;
        input.disabled = !ok;
        input.checked = state.size === size;
        input.addEventListener('change', function () {
          state.size = size;
          pruneColours();
          update();
        });
        var span = document.createElement('span');
        span.textContent = size;
        label.appendChild(input);
        label.appendChild(span);
        if (!ok) label.title = 'Sold out in every colour';
        sizeWrap.appendChild(label);
      });
    }

    function renderColours() {
      if (!colourWrap) return;
      var list = palette();
      var total = chosen();
      var remaining = pairs - total;

      colourWrap.innerHTML = '';

      list.forEach(function (col) {
        var ok = colourInStock(col, state.size);
        var qty = state.colours[col] || 0;

        var row = document.createElement('div');
        row.className = 'cuft-colour-row' +
          (qty > 0 ? ' is-active' : '') +
          (ok ? '' : ' is-out');

        var dot = document.createElement('span');
        dot.className = 'cuft-colour-row__dot';
        dot.style.background = swatchColor(col);
        row.appendChild(dot);

        var name = document.createElement('span');
        name.className = 'cuft-colour-row__name';
        name.textContent = col;
        row.appendChild(name);

        if (!ok) {
          var oos = document.createElement('span');
          oos.className = 'cuft-colour-row__oos';
          oos.textContent = state.size ? 'Sold out in ' + state.size : 'Unavailable';
          row.appendChild(oos);
        } else {
          var step = document.createElement('div');
          step.className = 'cuft-colour-row__step';

          var minus = document.createElement('button');
          minus.type = 'button';
          minus.className = 'cuft-step';
          minus.textContent = '\u2212';
          minus.setAttribute('aria-label', 'One fewer ' + col);
          minus.disabled = qty === 0;
          minus.addEventListener('click', function () {
            if ((state.colours[col] || 0) > 0) { state.colours[col]--; update(); }
          });

          var count = document.createElement('span');
          count.className = 'cuft-colour-row__count' + (qty === 0 ? ' is-zero' : '');
          count.textContent = String(qty);

          var plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'cuft-step';
          plus.textContent = '+';
          plus.setAttribute('aria-label', 'One more ' + col);
          plus.disabled = remaining <= 0;
          plus.addEventListener('click', function () {
            if (chosen() < pairs) {
              state.colours[col] = (state.colours[col] || 0) + 1;
              update();
            }
          });

          step.appendChild(minus);
          step.appendChild(count);
          step.appendChild(plus);
          row.appendChild(step);
        }

        colourWrap.appendChild(row);
      });

      if (tallyEl) {
        tallyEl.textContent = total + ' of ' + pairs + ' chosen';
        tallyEl.classList.toggle('is-done', total === pairs);
      }
      if (colourNote) {
        colourNote.textContent = remaining > 0 ? 'pick ' + remaining + ' more' : 'all set';
      }
      if (resetBtn) resetBtn.hidden = total === 0;
    }

    function renderCami() {
      if (!wantCami || !P.cami) return;
      var ck = optKey(P.cami, 'color');
      var sk = optKey(P.cami, 'size');

      if (camiColorWrap && ck) {
        var camiColors = uniqueValues(P.cami, ck);
        camiColorWrap.innerHTML = '';
        camiColors.forEach(function (col) {
          var any = P.cami.variants.some(function (v) {
            return String(v.opts[ck]).toLowerCase() === String(col).toLowerCase() && v.available;
          });
          var label = document.createElement('label');
          label.className = 'cuft-swatch' + (any ? '' : ' is-disabled');
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'camicolor-' + (tier.dataset.blockId || 'c');
          input.value = col;
          input.disabled = !any;
          if (any && !state.camiColor) state.camiColor = col;
          input.checked = state.camiColor === col;
          input.addEventListener('change', function () { state.camiColor = col; update(); });
          var dot = document.createElement('span');
          dot.className = 'cuft-swatch__dot';
          dot.style.background = swatchColor(col);
          var sr = document.createElement('span');
          sr.className = 'cuft-sr';
          sr.textContent = col;
          label.appendChild(input);
          label.appendChild(dot);
          label.appendChild(sr);
          label.title = col;
          camiColorWrap.appendChild(label);
        });
      }

      if (camiSizeWrap && sk) {
        var sizes = sortSizes(uniqueValues(P.cami, sk));
        camiSizeWrap.innerHTML = '';
        sizes.forEach(function (size) {
          var wanted = {};
          wanted[sk] = size;
          if (ck && state.camiColor) wanted[ck] = state.camiColor;
          var v = findVariant(P.cami, wanted);
          var ok = !!(v && v.available);
          var label = document.createElement('label');
          label.className = 'cuft-chip' + (ok ? '' : ' is-disabled');
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'camisize-' + (tier.dataset.blockId || 'c');
          input.value = size;
          input.disabled = !ok;
          if (ok && !state.camiSize) state.camiSize = size;
          input.checked = state.camiSize === size;
          input.addEventListener('change', function () { state.camiSize = size; update(); });
          var span = document.createElement('span');
          span.textContent = size;
          label.appendChild(input);
          label.appendChild(span);
          camiSizeWrap.appendChild(label);
        });
      }
    }

    /* ---------- cart payload ---------- */

    // Resolve the full line-item list for the current selection.
    function buildItems() {
      var prod = product();
      if (!prod || !state.size) return null;
      if (chosen() !== pairs) return null;

      var ck = optKey(prod, 'color');
      var sk = optKey(prod, 'size');
      var items = [];
      var ok = true;

      Object.keys(state.colours).forEach(function (col) {
        var qty = state.colours[col] || 0;
        if (!qty) return;
        var wanted = {};
        if (sk) wanted[sk] = state.size;
        if (ck) wanted[ck] = col;
        var v = findVariant(prod, wanted);
        if (!v || !v.available) { ok = false; return; }
        items.push({ id: v.id, quantity: qty });
      });
      if (!ok || !items.length) return null;

      if (wantCami && P.cami) {
        var cck = optKey(P.cami, 'color');
        var csk = optKey(P.cami, 'size');
        var cw = {};
        if (csk) cw[csk] = state.camiSize;
        if (cck) cw[cck] = state.camiColor;
        var cv = findVariant(P.cami, cw);
        if (!cv || !cv.available) return null;
        items.push({ id: cv.id, quantity: 1 });
      }

      if (wantWash && P.wash) {
        var wv = P.wash.variants.find(function (v) { return v.available; });
        if (!wv) return null;
        items.push({ id: wv.id, quantity: 1 });
      }

      return items;
    }

    // Full price of the bundle, independent of what's been picked so far, so the
    // price is correct from page load rather than blank until the set is complete.
    function fullPrice() {
      var prod = product();
      if (!prod || !prod.variants.length) return 0;
      var sum = prod.variants[0].price * pairs;
      if (wantCami && P.cami && P.cami.variants.length) sum += P.cami.variants[0].price;
      if (wantWash && P.wash && P.wash.variants.length) sum += P.wash.variants[0].price;
      return sum;
    }

    /* ---------- state -> UI ---------- */

    function update() {
      renderSizes();
      renderColours();
      renderCami();

      var compareEl = tier.querySelector('[data-cuft-compare]');
      var priceEl = tier.querySelector('[data-cuft-price]');
      var saveEl = tier.querySelector('[data-cuft-save]');

      var full = fullPrice();
      var bp = parseFloat(String(tier.dataset.bundlePrice).replace(/[^0-9.]/g, ''));
      var hasBundle = !isNaN(bp) && bp > 0 && Math.round(bp * 100) < full;

      if (hasBundle) {
        var bundleCents = Math.round(bp * 100);
        if (compareEl) compareEl.textContent = money(full);
        if (priceEl) priceEl.textContent = money(bundleCents);
        if (saveEl) saveEl.textContent = 'Save ' + money(full - bundleCents);
      } else {
        if (compareEl) compareEl.textContent = '';
        if (priceEl) priceEl.textContent = money(full);
        if (saveEl) saveEl.textContent = '';
      }

      var items = buildItems();
      var total = chosen();

      addBtn.disabled = !items;
      if (msgEl) {
        if (items) {
          msgEl.textContent = '';
        } else if (!state.size) {
          msgEl.textContent = 'Choose a size to get started.';
        } else if (total < pairs) {
          var left = pairs - total;
          msgEl.textContent = 'Choose ' + left + ' more pair' + (left === 1 ? '' : 's') + ' to continue.';
        } else {
          msgEl.textContent = 'That combination is out of stock. Try another size or colour.';
        }
      }

      tier._cuftItems = items;
    }

    /* ---------- events ---------- */

    styleInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        state.style = input.value;
        // Colour names and stock differ between bikini and thong, so start clean.
        state.size = null;
        state.colours = {};
        update();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state.colours = {};
        update();
      });
    }

    addBtn.addEventListener('click', function () {
      var items = tier._cuftItems;
      if (!items) return;
      var label = tier.querySelector('[data-cuft-add-label]');
      var original = label ? label.textContent : '';
      addBtn.disabled = true;
      if (label) label.textContent = 'Adding…';

      var cartDrawer = document.querySelector('cart-drawer');
      var cartSectionId = cartDrawer && cartDrawer.dataset.sectionId;

      var body = { items: items, sections_url: window.location.pathname };
      if (cartSectionId) body.sections = [cartSectionId];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
        .then(function (cartState) {
          // Apply the bundle discount code to the cart so it holds through the drawer.
          if (data.discountCode) {
            fetch('/discount/' + encodeURIComponent(data.discountCode), { method: 'GET' })
              .catch(function () {});
          }

          if (data.redirectToCheckout) {
            window.location.href = data.discountCode
              ? '/checkout?discount=' + encodeURIComponent(data.discountCode)
              : '/checkout';
            return;
          }
          // Send the customer to the cart page. The drawer is skipped because the
          // upsell app renders over the cart contents on desktop.
          window.location.href = '/cart';
          return;

          if (label) label.textContent = 'Added';
          setTimeout(function () { if (label) label.textContent = original; update(); }, 2000);

          if (cartDrawer && cartSectionId && cartState.sections && cartState.sections[cartSectionId]) {
            var sectionHtml = cartState.sections[cartSectionId];

            var applyRender = function () {
              var html = new DOMParser().parseFromString(sectionHtml, 'text/html');
              try { cartDrawer.purchaseHandler(html, cartState); } catch (e) {}
              try { cartDrawer.setPreEmpty && cartDrawer.setPreEmpty(false); } catch (e) {}
              try { cartDrawer.updateEmptyStatus && cartDrawer.updateEmptyStatus(); } catch (e) {}
              try { cartDrawer.updateViewport && cartDrawer.updateViewport(); } catch (e) {}

              // Force repaint: the drawer is a promoted compositing layer and does not
              // always invalidate after injected DOM changes.
              requestAnimationFrame(function () {
                cartDrawer.style.transform = 'translateZ(0)';
                void cartDrawer.offsetHeight;
                requestAnimationFrame(function () {
                  cartDrawer.style.transform = '';
                });
              });
            };

            applyRender();
            // Re-assert after other cart listeners (upsell apps, theme polling) settle.
            setTimeout(applyRender, 400);
            setTimeout(function () {
              fetch('/cart?section_id=' + cartSectionId)
                .then(function (r) { return r.text(); })
                .then(function (fresh) { sectionHtml = fresh; applyRender(); })
                .catch(function () {});
            }, 900);
          } else if (cartDrawer) {
            cartDrawer.open && cartDrawer.open();
          }

          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-count, .cart-count-bubble').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });

          document.dispatchEvent(new CustomEvent('cuft:bundle:added', { detail: { items: items } }));
        })
        .catch(function () {
          if (label) label.textContent = original;
          update();
          if (msgEl) msgEl.textContent = 'Unable to add to cart';
        });
    });

    update();
  }

  function setupModal(root) {
    var modal = root.querySelector('[data-cuft-modal]');
    if (!modal) return;
    var lastFocus = null;

    function show(which) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      selectTab(which === 'underwear' ? 'thong' : which);
      var close = modal.querySelector('[data-cuft-close]');
      if (close) close.focus();
    }
    function hide() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    function selectTab(name) {
      modal.querySelectorAll('[data-cuft-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', String(t.dataset.cuftTab === name));
      });
      modal.querySelectorAll('[data-cuft-chart]').forEach(function (c) {
        c.hidden = c.dataset.cuftChart !== name;
      });
    }

    document.querySelectorAll('[data-cuft-sizechart]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(btn.dataset.cuftSizechart); });
    });
    modal.querySelectorAll('[data-cuft-close]').forEach(function (b) {
      b.addEventListener('click', hide);
    });
    modal.querySelectorAll('[data-cuft-tab]').forEach(function (t) {
      t.addEventListener('click', function () { selectTab(t.dataset.cuftTab); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) hide();
    });
  }

  function init() {
    document.querySelectorAll('[data-cuft-bundles]').forEach(Bundles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cuft-bundles]');
    if (el) Bundles(el);
  });
})();